import React from 'react';

interface TimelineDotProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  borderColor?: string;
}

export function TimelineDot({
  size = 'md',
  color = 'bg-gray-200',
  borderColor = 'border-white',
}: TimelineDotProps): JSX.Element {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  return (
    <div className="w-4 flex flex-col items-center">
      <div
        className={`${sizeClasses[size]} ${color} rounded-full border-2 ${borderColor} z-10`}
      />
    </div>
  );
}
